/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * AILB API
 * Auto-generated OpenAPI specification for the AILB API
 * OpenAPI spec version: 1.0.0
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse } from "axios";

import type { FavoriteResponse, FavoriteToggleResponse } from "./models";

/**
 * @summary Get all favorites for the current user
 */
export const favoritesControllerGetFavorites = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FavoriteResponse>> => {
  return axios.get(`/api/proxy/favorites/`, options);
};

/**
 * @summary Add an app to favorites
 */
export const favoritesControllerAddFavorite = (
  appId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FavoriteToggleResponse>> => {
  return axios.post(`/api/proxy/favorites/${appId}`, undefined, options);
};

/**
 * @summary Remove an app from favorites
 */
export const favoritesControllerRemoveFavorite = (
  appId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FavoriteToggleResponse>> => {
  return axios.delete(`/api/proxy/favorites/${appId}`, options);
};

export type FavoritesControllerGetFavoritesResult =
  AxiosResponse<FavoriteResponse>;
export type FavoritesControllerAddFavoriteResult =
  AxiosResponse<FavoriteToggleResponse>;
export type FavoritesControllerRemoveFavoriteResult =
  AxiosResponse<FavoriteToggleResponse>;
